import React, { Component } from 'react';
import { EUIToggle } from '../../EUI/EUIToggle';

export class BlocRgpd extends Component {

    static defaultProps = {
        contact: {},
        onChange: (contact) => null,
    };

    _onChange = (key, value) => {
        const { contact, onChange } = this.props;
        const newContact = { ...contact, [key]: value, };
        onChange(newContact);
    };

    render = () => {

        const { contact } = this.props;

        return <div style={{ marginTop: "15px" }}>
            Le règlement général sur la protection des données (RGPD) a été adopté le 14 avril 2016 par le parlement Européen pour une mise en application à compter du 25 mai 2018.
            <br />
            <br />
            L'application du règlement (RGPD) dans l’application EIFFIMMO d'Eiffage Immobilier renforce la maîtrise des personnes sur leurs données par :
            <ul>
                <li>Le consentement à la collecte des données,</li>
                <li>La notification des violations de données (data breach notification),</li>
                <li>Le recours à la pseudonymisation,</li>
                <li>L'absence de profilage et de traitement automatisé des données,</li>
                <li>L'application du droit à l'oubli numérique,</li>
                <li>L'absence de transfert de données vers des pays non listés par la commission européenne.</li>
            </ul>
            Les données collectées par nos agents commerciaux vont permettre de constituer votre dossier d'acquisition d'un bien immobilier. Elles concernent donc votre état civil ainsi que la description de votre projet immobilier. Ces données seront utilisées par nos agents administratifs pour communiquer avec vous.<br />
            <br />
            A la fin de votre projet avec Eiffage Immobilier (parfait achèvement, abandon de votre recherche immobilière) vos données seront pseudonymisées c'est-à-dire que seuls les éléments relatifs à votre projet immobilier seront conservés sans aucun lien avec les données permettant de vous identifier.<br />
            <br />
            <div name="divConsentementCollecteDonneesPersonnelles">
                <EUIToggle
                    checked={contact.consentementCollecteDonneesPersonnelles}
                    className="toggleConsentement"
                    inlineLabel
                    label="Consentez-vous au recueil de vos données personnelles par Eiffage Immobilier pour la gestion administrative de votre dossier (cochez la case ci-contre) ? "
                    onChange={(e, isChecked) => this._onChange("consentementCollecteDonneesPersonnelles", isChecked)}
                />
            </div>
            <br />
            Si vous souhaitez révoquer ce consentement vous pouvez le signifier en écrivant à :
            <br />
            Eiffage Immobilier – EIFFIMMO<br />
            11 place de l'Europe<br />
            78140 Vélizy Villacoublay<br />
            <br />
            Ou par e-mail : <a href="mailto:immocom.eiffage-immobilier@eiffage.com">immocom.eiffage-immobilier@eiffage.com</a><br />
            <br />
            Ou en vous connectant à votre espace personnel
        </div>;

    };

};